module.exports = __webpack_public_path__ + "static/media/odpr.2f89a9f0.jpg";